import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { historyImages } from 'assets/media/weAre';
import styles from './History.module.scss';
import Timeline from './Timeline';

interface TranslatedYear {
  year: string;
  description: { title: string; text: string };
}

const History = (): ReactElement => {
  const { t } = useTranslation();

  const translatedYears = t('pages.weAre.yearsDescriptions', {
    returnObjects: true,
  }) as unknown as TranslatedYear[];

  // Images live outside the catalog so they are not duplicated per language.
  const yearsDescriptions = translatedYears.map((year, index) => ({
    ...year,
    imageUrl: historyImages[index],
  }));

  return (
    <div className={styles.Container}>
      <Row justify="center">
        <Col span={24}>
          <h2 className={styles.Title}>{t('pages.weAre.historyTitle')}</h2>
          <p>{t('pages.weAre.historyText')}</p>
        </Col>
      </Row>
      <Timeline yearsDescriptions={yearsDescriptions} />
    </div>
  );
};

export default History;
